import tracking from "../tracking/tracking";

function findAttrInAncestors(element, attr) {
  if (!element || element == document.body) {
    return null;
  }
  if (element.getAttribute && element.getAttribute(attr)) {
    return element;
  }
  return findAttrInAncestors(element.parentNode, attr);
}

export default async function initDomTracking() {
  await tracking.init();

  document.addEventListener("click", (event) => {
    const element = findAttrInAncestors(event.target, "data-tk-click");
    if (element) {
      const eventName = element.getAttribute("data-tk-click");
      const paramsJson = element.getAttribute("data-tk-params");
      let params = {};
      if (paramsJson) {
        params = JSON.parse(paramsJson);
      }
      tracking.track(eventName, params);
    }
  });
}
